<!-- 財務 -> 应收管理 -> 应收汇总 -->
<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix no_print">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_predict_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始预收日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_predict_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束预收日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
            <!-- multiple collapse-tags filterable -->
            <el-select class="search_select search_inputBox" v-model="params.search.customer_id" filterable  placeholder="客户名称" @visible-change="getSelectList('customerSelect')">
                <el-option v-for="list in selectMap.customerSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer> -->
            <el-select class="search_select search_inputBox" v-model="params.search.salesman_id" multiple collapse-tags placeholder="销售人" @visible-change="getSelectList('user')">
                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-input class="search_select search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input> -->
            <el-select class="search_select search_inputBox" v-model="params.search.status" placeholder="订单状态">
                <el-option :value="999" label="全部订单状态"></el-option>
                <el-option :value="1" label="等待财务审核"></el-option>
                <el-option :value="2" label="待出库"></el-option>
                <el-option :value="3" label="部分出库"></el-option>
                <el-option :value="33" label="退货单"></el-option>
                <el-option :value="4" label="全部出库"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.search.settlement_status" placeholder="结算状态">
                <el-option :value="999" label="全部结算状态"></el-option>
                <el-option :value="1" label="未结算"></el-option>
                <el-option :value="2" label="部分结算"></el-option>
                <el-option :value="3" label="全部结算"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.search.invoice_status" placeholder="开票状态">
                <el-option :value="999" label="全部开票状态"></el-option>
                <el-option :value="1" label="未开票"></el-option>
                <el-option :value="2" label="已开票"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.search.rec" placeholder="REC状态" v-if="isShowMore">
                <el-option :value="999" label="全部REC状态"></el-option>
                <el-option :value="0" label="否"></el-option>
                <el-option :value="1" label="是"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.search.account_id" multiple collapse-tags placeholder="收款账户" @visible-change="getSelectList('accountOptions')">
                <el-option v-for="list in selectMap.accountOptions" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="start_audit_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="审核开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_audit_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="审核结束日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="clear_start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结算开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="clear_end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结算结束日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="start_out_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始出入日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_out_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束出入日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox"  v-if="isShowMore" v-model="params.search.remark" placeholder="销售单备注"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="sousuoBtn" @click="openSou"></div>
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='finance.receivables';isGlobal=false;filter=copy_filter;"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <!-- <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="batchOrderOut">审核通过</el-button>
        </div> -->
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" scene="finance.receivables" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @rowClick="rowClick" @getRow="getRow"
                      @hoverClick="hoverClick" @sortTable="sortList"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">销售金额:{{totalObj.sales_amount}}</div>
            <div class="totalNumber">应收金额:{{totalObj.receivable_amount}}</div>
            <div class="totalNumber">优惠金额:{{totalObj.reduce_amount}}</div>
            <div class="totalNumber">税金:{{totalObj.tax_amount}}</div>
            <div class="totalNumber">含税价税金:{{totalObj.tax_manual}}</div>
            <div class="totalNumber">已结金额:{{totalObj.already_amount}}</div>
            <div class="totalNumber">未结金额:{{totalObj.outstanding_amount}}</div>
            <div class="totalNumber">已开票金额:{{totalObj.invoice_yes}}</div>
            <div class="totalNumber">未开票金额:{{totalObj.invoice_no}}</div>
            <div class="totalNumber">选中应收金额:{{selectGetMoney}}</div>
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 销售单 / 退货单 dialog START -->
            <sale-bill-base ref="saleBillBase" v-if="dialogVisible" :dialog="dialogVisible" @hide="dialogVisible=false" @sceneEnd="dialogVisible=true"
                            :dt="3" :form-data="detailInfo" :scene="saleBillScene" :source="saleBillSource" @bill="syncBill" @retrunDetail="retrunDetail">
                <div class="editBtnList clearfix" v-if="saleBillSource==='order'" >
                    <div class="editTax clearfix" style="margin-bottom: 10px;">
                        <div class="editTaxname">客户余额：{{bill.balance}}</div>
                    </div>
                    <div style="float:left;margin-bottom: 10px">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div>
                    </div>
                    <div class="editBtn" style="margin-bottom: 10px;">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="detailInfo.isInout" @click="addDialogVisible = true;add_params.order_id=detailInfo.id;add_params.order_sn=detailInfo.order_sn;add_params.customer_id=detailInfo.customer_id;add_params.customer_name=detailInfo.customer_name;add_params.bill_type=0;add_params.payment_type_id=detailInfo.payment_type_id;add_params.account_id=detailInfo.account_id;add_params.course_title='进销货款'">收款</el-button>
                        <el-button class="funcPublicBtn" v-if="detailInfo.isOrderOutPass" @click="orderOut([detailInfo.id])">审核通过</el-button>
                        <el-button class="funcPublicBtn" v-if="detailInfo.isSettlement" @click="settlement()">结算</el-button>
                        <!-- <el-button class="funcPublicBtn" v-if="detailInfo.isSettlement" @click="sureDialogVisible = true;sure_params.order_id=detailInfo.id;sure_params.amount=detailInfo.outstanding;sure_params_amount = detailInfo.outstanding;">结算</el-button> -->
                        <el-button class="funcPublicBtn" v-if="detailInfo.id&&module.includes(',finance-doc-receivable-print,')" @click="print(2);">打印</el-button>
                        <el-button class="funcPublicBtn" @click="openBill">开发票</el-button>
                        <el-button class="funcPublicBtn" v-if="detailInfo.id&&module.includes(',finance-doc-receivable-export,')" @click="exportExcelBill">导出</el-button>
                    </div>
                </div>
                <div class="editBtnList clearfix" v-else-if="saleBillSource==='return'">
                    <div class="editTax clearfix" style="margin-bottom: 10px;">
                        <div class="editTaxname">客户余额：{{bill.balance}}</div>
                    </div>
                    <div class="editBtn" style="margin-bottom: 10px">
                        <el-button class="funcPublicBtn" v-if="detailInfo.isSettlement" @click="settlement();sure_params.remark='销售退款到余额'">结算</el-button>
                        <!-- <el-button class="funcPublicBtn" v-if="detailInfo.isSettlement" @click="sureDialogVisible = true;sure_params.order_id=detailInfo.id;sure_params.amount=detailInfo.outstanding;sure_params_amount = detailInfo.outstanding;sure_params.remark='销售退款到余额'">结算</el-button> -->
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="detailInfo.isPayment" @click="addDialogVisibleBack = true;add_params.order_id=detailInfo.id;add_params.order_sn=detailInfo.order_sn;add_params.customer_id=detailInfo.customer_id;add_params.customer_name=detailInfo.customer_name;add_params.bill_type=1;add_params.payment_type_id=detailInfo.payment_type_id;add_params.account_id=detailInfo.account_id;add_params.course_title='销售退款'">付款</el-button>
                        <el-button class="funcPublicBtn" v-if="detailInfo.id&&module.includes(',finance-doc-receivable-print,')" @click="print(3);">打印</el-button>
                    </div>
                </div>
            </sale-bill-base>
        <!-- 销售单 /退货单 dialog END -->

        <!-- 关联应收费用 START -->
        <fee-relation-sale :hasRec="rec" :id="relativeId" :purl="relativePostUrl" :post="isRelativePost" :dialogVisibleRelation="dialogVisibleRelation" :relatedremark="relatedremarkC" :data="relateListC" :isEdit="isEditRelative" @confirm="()=>{this.getList()}" @closeDialog="()=>{this.dialogVisibleRelation = false;}"></fee-relation-sale>

        <!-- 关联应收费用 END -->
        <!-- 新增收款单 dialog START -->
        <el-dialog v-dialog-drag title="新增收款单" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="销售单号：">
                        <el-input v-model="add_params.order_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称：">
                        <el-input  v-model="add_params.customer_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.amount"  @input.native="changeaddAmounta($event,add_params.amount)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->

        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag title="新增付款单" :visible.sync="addDialogVisibleBack" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="退货单号：">
                        <el-input v-model="add_params.order_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="invoice_time" disabled type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="付款账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称：">
                        <el-input  v-model="add_params.customer_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.amount" @input.native="changeaddAmount($event,add_params.amount)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBack=!addDialogVisibleBack">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheetBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->

        <!-- 开发票 dialog START -->
        <el-dialog v-dialog-drag title="开发票" :visible.sync="addDialogVisibleBill" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_billParams" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="发票抬头：">
                        <el-input v-model="add_billParams.title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票名称：">
                        <el-input v-model="add_billParams.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票号码：">
                        <el-input v-model="add_billParams.code" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票金额：">
                        <el-input v-model="add_billParams.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="销售单号：">
                        <el-input v-model="add_billParams.order_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_billParams.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBill=!addDialogVisibleBill">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderBill">确定</el-button>
            </div>
        </el-dialog>
        <!-- 开发票 dialog END -->

        <!-- 结算确认 dialog START -->
        <el-dialog v-dialog-drag title="结算确认" :visible.sync="sureDialogVisible" class="eldialog eldialogLine" :model="false">
            <el-form :model="sure_params" ref="sure_form" class="dialogFormB clearfix">
                 <div class="eldialogFormBox" style="padding: 10px 15px 20px 15px;">
                    <el-form-item label="客户余额：">
                        <div style="text-align:left;">{{bill.balance}}</div>
                    </el-form-item>
                    <el-form-item  label="结算时间：" >
                        <el-date-picker v-model="sure_params.settlement_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结算RMB金额：">
                        <el-input v-model="sure_params.amount"  @input.native="changeAmount($event,sure_params.amount)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="优惠：">
                        <el-input v-model="sure_params.reduce_amount" @input.native="changeRate($event,sure_params.reduce_amount)"  placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <textarea class="edit_input edit_textarea" v-model="sure_params.remark" style="width: 140px;line-height: 30px;"></textarea>
                    </el-form-item>
                </div>
            </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" style="margin-right: 20px;" @click="settlementConfirm">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn"  @click="sureDialogVisible = false">取消</el-button>
                </div>
        </el-dialog>
        <!-- 结算确认 dialog END -->
        <!-- 列表修改 dialog START -->
        <el-dialog v-dialog-drag title="其他收款修改" :visible.sync="otherVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="其他收款" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.other_amount" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"  v-model="listDetailObj.other_amount_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="otherChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outOtherVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog v-dialog-drag title="优惠修改" :visible.sync="reduceVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="优惠" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.reduce_amount" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"  v-model="listDetailObj.reduce_amount_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="reduceChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outReduceVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog v-dialog-drag title="含税价税金" :visible.sync="taxVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item label="金额" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.tax_manual" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"  v-model="listDetailObj.tax_manual_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="taxChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outTaxVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!-- 
            <el-dialog v-dialog-drag :title="listDetailObj.type==1?'运费修改':listDetailObj.type==2?'税金修改':listDetailObj.type==3?'其他收款修改':listDetailObj.type==4?'优惠修改':''" :visible.sync="listDialogVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form :model="sure_params" ref="sure_form">
                <div class="eldialogFormBox">
                    <el-form-item :label="listDetailObj.type==1?'运费':listDetailObj.type==2?'税金':listDetailObj.type==3?'其他收款':listDetailObj.type==4?'优惠':''" class="other_form_item" style="width:80%">
                        <el-input v-model="listDetailObj.amount" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <textarea class="edit_input edit_textarea" placeholder="备注" style="width:65%;"  v-model="listDetailObj.remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="listChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="listDialogVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog> 
        -->
        <!-- 列表修改 dialog END -->
        <!--查看已开票 START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleBill" class="eldialog eldialogStock" width="920px" :modal="false" title="开票记录" custom-class="full_dialog">
            <pay-list-dialog ref="selectStock" :id="seeBillList_id" :type="1"></pay-list-dialog>
        </el-dialog>
        <!--查看已开票 END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="finance.receivables" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 修改备注 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleHoverClick" class="eldialog eldialogOneLabel" width="400px" :modal="false" :title="hoverClickObj.title" custom-class="full_dialog">
            <div class="">
                <el-form>
                    <el-form-item :label="hoverClickObj.title+':'">
                        <el-input class="edit_input" v-model="hoverClickObj.val" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="hoverClickConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleHoverClick = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改备注 END -->
        <el-dialog v-dialog-drag title="客户信息" class="eldialog eldialogA" :visible.sync="customerDetail" :model="false" custom-class="full_dialog">
            <div class="">
                <el-form :model="form_params" :rules="rules" ref="edit_form" style="overflow-y: auto;max-height: 600px;">
                    <div class="dialog_path_title eldialogFormTag">基本信息</div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="公司名称：" prop="name">
                            <el-input class="edit_input" v-model="form_params.name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址：" prop="address">
                            <el-input class="edit_input" v-model="form_params.address" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="所属人：" prop="salesman_name">
                            <el-input class="edit_input" v-model="form_params.salesman_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="电话/传真：" prop="fax">
                            <el-input class="edit_input" v-model="form_params.fax" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="工厂规模：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_size" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="厂房信息：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_info" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="采购木种：" prop="wood_category">
                            <el-input class="edit_input" v-model="form_params.wood_category" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="其他信息：" prop="other_info">
                            <el-input class="edit_input" v-model="form_params.other_info" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="所在省份：" prop="province_name">
                            <el-input class="edit_input" v-model="form_params.province_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="所在城市：" prop="city_name">
                            <el-input class="edit_input" v-model="form_params.city_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="客户属性：" prop="customer_attribute_name">
                            <el-input class="edit_input" v-model="form_params.customer_attribute_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="客户来源：" prop="customer_source_name">
                            <el-input class="edit_input" v-model="form_params.customer_source_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="主营项目：" prop="main_business">
                            <el-input class="edit_input" v-model="form_params.main_business" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="信用指数：" prop="star">
                            <el-select class="edit_input" v-model="form_params.star" :disabled="isSeeEdit">
                                <el-option :value="1" :label="'一星'"></el-option>
                                <el-option :value="2" :label="'二星'"></el-option>
                                <el-option :value="3" :label="'三星'"></el-option>
                                <el-option :value="4" :label="'四星'"></el-option>
                                <el-option :value="5" :label="'五星'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户文件：" v-if="form_params.files">
                            <span style="float: left;font-size: 12px;color: #b21111;" @click="openFile">资料查看</span><img  @click="openFile" class="file" src="/icon/file.png">
                        </el-form-item>
                        <el-form-item v-else>
                        </el-form-item>
                        <div class="mark">
                            <el-form-item label="备注：" prop="remark">
                                <!-- <el-input class="edit_input" v-model="form_params.remark" placeholder=""></el-input> -->
                                <div class="content_box">
                                    <span class="content">{{form_params.remark}}</span>
                                    <span class="edit cursorPointer" :disabled="isSeeEdit" @click="markEdits"></span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="dialog_path_title eldialogFormTag">联系方式</div>
                    <template v-for="(item,index) in form_params.contacts">                
                        <div :class="['link_item', index == 0 ? '':'add_item']" :key="index">
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="联系人：" :prop="`contacts[${index}].contact`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.contact" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话：" :prop="`contacts[${index}].phone`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.phone" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>            
                            </div>
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="微信：">
                                    <el-input v-model="item.wechat" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                                <el-form-item label="电子邮箱：">
                                    <el-input v-model="item.email" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                            </div>
                            <!-- <div :class="['item_icon','cursorPointer',index == 0 ? 'add_icon':'del_icon']"  @click="addOrDelete(index)"></div> -->
                        </div>
                    </template>    
                    <div class="dialog_path_title eldialogFormTag">开票资料</div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="名称：" prop="invoice_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行：" prop="invoice_bank_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="税号：" prop="invoice_no">
                            <el-input class="edit_input" v-model="form_params.invoice_no" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="账号：" prop="invoice_bank_no">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_no" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="地址：" prop="invoice_addr">
                            <el-input class="edit_input" v-model="form_params.invoice_addr" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="invoice_phone">
                            <el-input class="edit_input" v-model="form_params.invoice_phone" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <!-- <el-button  class="publicBtn dialogBtn" @click="addCustomer">确定</el-button> -->
                <el-button class="dialogBtn funcPublicBtn" @click="customerDetail=!customerDetail">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="备注" :visible.sync="markDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="markhandleCloses" v-dialogDrag>
            <div>
                <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength=100 v-model="form_params.remark" :disabled="isSeeEdit"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="markDialogVisibles=false">确认</el-button>
            </span>
        </el-dialog>
        <!-- 搜索弹框 -->
        <el-dialog title="客户搜索" :visible.sync="customerDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="customerCloses" v-dialogDrag>
            <div style="padding:10px;">
                <el-input placeholder="请输入客户名称" maxlength=100 v-model="params.search.customer_name"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="Customerion()">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:14px; font-weight:bold; line-height:25px; color: #606266;padding-bottom:20px;background-color: #fff;}
    .file{width: 20px;float: left;margin-left: 5px;margin-top: 1px;}
    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .order_header{
        font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
        .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
    }
    .bottom_flex{ padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }

    .sub_container{
        display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff;
        .filter_path{
            padding: 15px; background-color: #F4F5F9; margin-bottom: 12px;
            .form-inline{
                & > div{
                    margin-right: 20px;
                    button { margin-left: 15px; }
                }
            }
            .filter_input{
                width: 123px;
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 0px 0 6px;
            // .excel_btn{
            //     color: #B21111; cursor: pointer;
            // }
        }
        .table_path{ flex: 1; }
        .statistics{
            background: #F7F8FA; padding: 12px 23px; line-height:18px; margin-top: 10px; display: flex; align-items: flex-start; font-size: 15px; color: #333333;
            & > div:last-child{
                flex: 1; margin-left: 26px;
                & > div:last-child{
                    margin-top: 17px;
                }
                & > div > span + span{ margin-left: 80px; }
            }
        }
        // dialog START
        .order_header{
            font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
            .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
        }
        .order_dialog{
            .edit_select{ width: 151px; }
            .edit_input{ width: 116px; }
            .order_base{ margin-bottom: 15px; }
            .flex{
                display: flex; align-items: center; justify-content: space-between;
                & > div { margin-bottom: 12px; }
                .edit_input{ width: 151px; }
            }
            .order_other{
                display: flex; align-items: stretch; border: 1px solid #707070; border-left: 0px none;
                & > div{ flex: 1; border-left: 1px solid #707070; }
                & > div:first-child{ padding: 11px 0 9px 50px; }
                .label_no_padding_form > div{ margin-bottom: 4px; }
                .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
            }
            .order_footer{ display: flex; font-size:16px; line-height:22px; display: flex; padding: 8px 28px 0 32px; align-items: center; justify-content: space-between; }
        }
        .dialog-footer{ display: flex; align-items: center; justify-content: space-between; font-size:16px; color: #333333; }
        // dialog END
        // add_dialog START
        .add_dialog_form{
            & > div{ margin-bottom: 9px; }
            .btn_row{ padding-top: 23px; text-align: center; }
            .edit_input{ width: 100%; }
        }
        // add_dialog END
        // sure_dialog START
        .sure_dialog_form{
            & > div{ margin-bottom: 15px; }
            .btn_row{ padding-top: 23px; text-align: right; }

            .remark{
                display: flex; align-items: stretch; justify-content: space-between; background: #fff; color: #000000; font-size: 12px; padding: 5px 12px;
                textarea{ background: #FFFFFF; border-radius:3px; height:84px; resize: none; border: 0px none; outline: none; flex: 1;  }
            }
        }
        // sure_dialog END
    }
    .mark{
        .content_box{
            width: 140px; 
            border-bottom: 1px solid #DCDFE6;
            display:flex;
            padding-left: 10px;
            .content{
                flex: 1;
                display: inline-block;
                width: 120px;
                height: 24px;
                text-align:left;
                overflow:hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
            }
            .edit{
                display:inline-block;
                width:20px;
                background: url(/icon/operation_edit.png) 100% 65% no-repeat;
                background-size: 16px 16px;
            }         
        }
    }
</style>
<script>
    import pagination from '../../components/pagination.vue';
    import tabletem from '../../components/table.vue';
    import feeRelationSale from '../../components/feeRelationSale.vue';
    import selectDownCustomer from '../../components/selectDownCustomer.vue';
    import saleBillBase from '../../components/saleBillBase';

    const initSearchParams = {
        page:1,
        per_page:50,
        sort:"",
        order:"",
        search:{
            order_sn:"",
            sales_time:"",
            start_time:"",
            end_time:"",
            start_predict_time:"",
            end_predict_time:"",
            customer_id:"",
            salesman_id:"",
            account_id:"",
            settlement_status:[],
            status:"",
            customer_name:"",
            rec:999,
            invoice_status:999
        }
    };
    export default {
        components:{
            pagination,
            tabletem,
            feeRelationSale,
            selectDownCustomer,
            saleBillBase
        },
        data(){
            return{
                selectGetMoney:0,
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.includes("board-america"),
                boardAfricaType:localStorage.dw_erp_board.includes("board-africa"),
                isShowMore:false,
                dialogVisibleWidth:false,
                isGlobal:false,
                companyName:localStorage.dw_erp_company_name,
                billColumn:"",
                scene:"",
                widthList:[],
                start_time: "",
                end_time: new Date(),
                start_predict_time:"",
                end_predict_time:"",
                params: this.$cloneJson(initSearchParams),
                billRecoedParam:{
                    page: 1,
                    per_page: 50,
                    search: {
                        start_time: "",
                        end_time: "",
                        order_id: ""
                    }
                },
                seeBillList_id:"",
                last_page: 10,
                total:0,
                list : [],
                summary:{
                    sales_amount : 0,
                    reduce_amount : 0,
                    already_amount : 0,
                    outstanding_amount : 0,
                },
                selectMap:{
                    customer:[],
                    user:[],
                    accountOptions:[],
                    account:[],
                    paymentType:[],
                    lockLevel:[],
                    customerSelect:[]
                },
                bill:{},
                listDialogVisible:false,
                otherVisible:false,
                reduceVisible:false,
                taxVisible:false,
                rec:true,
                // dialog START
                dialogVisible : false,
                saleBillScene:'',
                saleBillSource:'',
                detailInfo:{},
                dialogVisibleBack:false,
                addDialogVisibleBack:false,
                addDialogVisibleBill:false,
                dialogVisibleBill:false,
                listDetail:[
                    {id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}
                ],
                printDetail:{
                    fields:""
                },
                printTotal:[],
                dialogVisibleRelation:false,
                add_billParams:{
                    invoice_time:"",
                    title:"",
                    order_id:"",
                    name:"增值税专用发票",
                    code:"",
                    amount:"",
                    remark:""
                },
                invoice_time:"",
                // DIALOG END
                // 新增收款单 dialog START
                addDialogVisible: false,
                order_sn : "",
                trading_time : new Date(),
                add_params : {
                    order_id : "",
                    bill_type : "",
                    amount : "",
                    account_id : "",
                    customer_id : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                // 新增收款单 dialog END
                // 结算确认 dialog START
                sureDialogVisible : false,
                sure_params : {
                    order_id : "",
                    settlement_time:new Date(),
                    amount : "",
                    reduce_amount:"",
                    remark : ""
                },
                // 结算确认 dialog END
                tableCol:[
                    {colName:"单号",colKey:"order_sn",colWidth:190,isCanClick:true,isColor:true},
                    {colName:"订单状态",colKey:"status_text",colWidth:95,isColor:true},
                    {colName:"单据日期",colKey:"sales_time",colWidth:100,isSort:true,isColor:true},
                    {colName:"预计收款",colKey:"predict_time",colWidth:100,isSort:true,isColor:true},
                    {colName:"审核日期",colKey:"audit_time",colWidth:100,isSort:true,isColor:true},
                    {colName:"结算日期",colKey:"settlement_time",colWidth:100,isSort:true,isColor:true},
                    {colName:"出入日期",colKey:"out_time",colWidth:100,isSort:true,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:70,isColor:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isCanClick:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:85,isColor:true},
                    {colName:"折扣金额",colKey:"discount_amount",colWidth:85,isColor:true},
                    {colName:"应收金额",colKey:"receivable_amount",colWidth:85,isColor:true},
                    {colName:"已结金额",colKey:"already_amount",colWidth:85,isColor:true},
                    {colName:"未结金额",colKey:"outstanding",colWidth:85,isColor:true},
                    {colName:"关联应收",colKey:"traffic_amount",colWidth:70,isCanClick:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"税金",colKey:"tax_amount",colWidth:70,isCanClick:false,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"其它收款",colKey:"other_amount",colWidth:70,isCanClick:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"REC状态",colKey:"rec_text",colWidth:70,isCanClick:false,isColor:false,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"优惠",colKey:"reduce_amount",colWidth:70,isCanClick:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"含税价税金",colKey:"tax_manual",colWidth:70,isCanClick:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"已开票",colKey:"invoice_yes",colWidth:85,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true,isCanClickUnInclude:',0.00,'},
                    {colName:"未开票",colKey:"invoice_not",colWidth:85,isColor:true},
                    {colName:"销售单备注",colKey:"remark",colWidth:150,isColor:true,isHoverClick:true},
                    {colName:"查看详情",colKey:"see",colWidth:85,isCanClick:true,isColor:true},
                    {colName:"收款账户",colKey:"account_name",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                selectRow:[],
                totalObj:{},
                listDetailObj:{
                    id: "",
                    reduce_amount:"",
                    reduce_amount_remark:"",
                    other_amount:"",
                    other_amount_remark:"",
                    tax_manual:"",
                    tax_manual_remark:"",
                },
                filterDialogVisible:false,
                filter:"",
                copy_filter:"",
                fields:"",
                sure_params_amount:"",
                start_audit_time:"",
                end_audit_time:"",
                clear_start_time:"",
                clear_end_time:"",
                start_out_time:"",
                end_out_time:"",
                tableTotal:{
                  sales_amount:0.00,
                  discount_amount:0.00,
                  tax_amount:0.00,
                  traffic_amount:0.00,
                  other_amount:0.00,
                  reduce_amount:0.00,
                  receivable_amount:0.00,
                  invoice_no:0.00,
                  invoice_yes:0.00
                },
                printType:2,//2销售单打印  3退货单打印
                isEditRelative:false,
                isRelativePost:false,
                relativeId:"",
                relativePostUrl:"",
                relatedremarkC:"",
                relateListC:[],
                dialogVisibleHoverClick:false,
                hoverClickObj:{
                    id:"",
                    title:"",
                    val:"",
                    posturl:"",
                    key:""
                },
                newFee:[],
                customerDetail:false,
                form_params : {
                    id:"",
                    name : "",
                    salesman_id : "",
                    // linkman : "",
                    // phone : "",
                    address : "",
                    province_id : "",
                    city_id : "",
                    // email : "",
                    main_business : "",
                    remark : "",
                    // wechat: "",
                    fax: "",
                    customer_attribute_id: "",
                    customer_source_id: "",
                    star:"",
                    invoice_name:"",
                    invoice_no:"",
                    invoice_bank_name:"",
                    invoice_bank_no:"",
                    invoice_addr:"",
                    invoice_phone:"",
                    factory_size:"",
                    factory_info:"",
                    wood_category:"",
                    other_info:"",
                    contacts:[
                         {contact: '', phone:'', wechat: '', email: ''}
                    ],
                },
                rules: {
                    name : [ { required: true, message: '请输入公司名称', trigger: 'blur' } ],
                    address : [ { required: true, message: '请输入公司地址', trigger: 'blur' } ],
                    salesman_id : [ { required: true, message: '请选择归属人', trigger: 'blur' } ],
                    // linkman : [ { required: true, message: '请输入联系人', trigger: 'blur' } ],
                    // phone : [ {required: true,  message: '请输入联系电话', trigger: 'blur' } ]
                },
                isSeeEdit:false,
                markDialogVisibles:false,
                refreshSale:{},//刷新销售单弹框
                customerDialogVisibles:false
            }
        },
        created() {
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getSelectList('paymentType');
            this.getSelectList('account');
            this.getSelectList('customerSelect');
        },
        methods:{
            //备注编辑
            markEdits(){
                this.markDialogVisibles = true
                this.markCopy = this.form_params.remark
            },
            //弹窗关闭回调
            markhandleCloses(){
                this.markDialogVisibles=false 
                this.form_params.remark = this.markCopy
            },
            openFile(){
                 window.open(this.form_params.files)
            },
            //备注修改确定
            hoverClickConfirm(){
                let obj = new Object();
                obj.id = this.hoverClickObj.id;
                obj[this.hoverClickObj.key] = this.hoverClickObj.val;
                this.postFuncLoading(this.hoverClickObj.posturl,obj,()=>{
                    this.tip("修改成功","success")
                    this.getList()
                    this.dialogVisibleHoverClick = false;
                })
            },
            hoverClick(row){
                this.hoverClickObj.id = row.id;
                if(row.hoverClickName == 'remark'){
                    this.hoverClickObj.val = row.remark;
                    this.hoverClickObj.title = "备注";
                    this.hoverClickObj.posturl = "/erp/order.update.remark";
                    this.hoverClickObj.key = "remark";
                }
                this.dialogVisibleHoverClick = true;
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            openRelative(flag,id,url){
                this.isEditRelative = flag;
                this.isRelativePost = flag;
                if(id){
                    this.relativeId = id;
                }
                if(url){
                    this.relativePostUrl = url
                }
                if(flag){
                    this.postFuncLoading('/erp/finance.get.relate.receivables',{id:id},res=>{
                        this.relatedremarkC = res.data.data.related_remark;
                        this.relateListC = res.data.data.relate_list;
                        this.dialogVisibleRelation = !this.dialogVisibleRelation;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{    
                    this.dialogVisibleRelation = !this.dialogVisibleRelation;
                    this.relatedremarkC = this.detailInfo.related_remark;
                    this.relateListC = this.detailInfo.relate_list;
                }
            },
            excelExport(){
                this.$exportExecl("/erp/export.receivables","应收汇总",this.params)
            },
            settlementInput(val){
                var reg = /(^[1-9][0-9]{0,8}([.][0-9]{0,2})?$)|(^0?(\.[0-9]{0,2})?$)/;
                if(reg.test(val)){
                    this.sure_params.amount = val;
                    this.sure_params_amount = val;
                }else{
                    this.sure_params.amount = this.sure_params_amount;
                }
            },
            exportExcelBill(){
                this.$exportExecl("/erp/order.export","销售单",{id:this.detailInfo.id,"scene":"finance.order.column"})
            },
            
            print(type){
                let category = 4;
                this.printType = type;
                if(type == 3){
                    category = 6;
                }
                let url = "/saleOrderPrint?id=" + this.detailInfo.id + "&category=" + category;
                window.open(url);
            },
            filterConfirm(){
                this.getList();
            },
            syncBill(e) {
                this.bill = e;
            },
            //点击开发票
            openBill(){
                this.invoice_time=new Date();
                this.add_billParams.order_id=this.detailInfo.id;
                this.add_billParams.order_sn=this.detailInfo.order_sn;
                this.add_billParams.title=this.detailInfo.customer_name;
                this.add_billParams.amount=this.detailInfo.receivable_amount;
                this.addDialogVisibleBill=!this.addDialogVisibleBill;
            },
            openSou(){
                this.customerDialogVisibles = true
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="user"){
                    obj.show_disabled = 1;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            outOtherVisible(){
                this.otherVisible =false;
                this.listDetailObj.other_amount='';
            },
            outReduceVisible(){
                this.reduceVisible = false;
                this.listDetailObj.reduce_amount='';
            },
            outTaxVisible(){
                this.taxVisible = false;
                this.listDetailObj.tax_manual='';
            },
            listChangeSure(){
                this.postFunc("/erp/finance.update",this.listDetailObj,()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.listDialogVisible=false;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            otherChangeSure(){
                this.postFunc("/erp/finance.update",{
                    id:this.listDetailObj.id,
                    other_amount:this.listDetailObj.other_amount,
                    other_amount_remark:this.listDetailObj.other_amount_remark
                },()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.outOtherVisible();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            reduceChangeSure(){
                this.postFunc("/erp/finance.update",{
                    id:this.listDetailObj.id,
                    reduce_amount:this.listDetailObj.reduce_amount,
                    reduce_amount_remark:this.listDetailObj.reduce_amount_remark
                    },()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.outReduceVisible();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            taxChangeSure(){
                this.postFunc("/erp/finance.update",{
                    id:this.listDetailObj.id,
                    tax_manual:this.listDetailObj.tax_manual,
                    tax_manual_remark:this.listDetailObj.tax_manual_remark
                    },()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.outTaxVisible();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBillMess(id){
                this.postFunc("/erp/customer.detail",{id:id},response=>{
                    this.bill=response.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //结算
            settlement(){
                this.sureDialogVisible = true;
                this.sure_params.order_id=this.detailInfo.id;
                this.sure_params.amount=this.detailInfo.outstanding;
                this.sure_params_amount = this.detailInfo.outstanding;
                this.sure_params.reduce_amount = this.detailInfo.reduce_amount;
                // this.sure_params.remark='销售退款到余额'
            },
            settlementConfirm(){
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sure_params.settlement_time = this.formatTimeZero(this.sure_params.settlement_time);
                    this.postFuncLoading("/erp/finance.settlement",this.sure_params,()=>{
                        this.tip("结算成功","success")
                        this.sureDialogVisible=false;
                        // this.dialogVisible=false;
                        //this.detailInfo.outstanding-=this.sure_params.amount;
                        let obj = {name:"order_sn",id:this.detailInfo.id}
                        this.getBillMess(this.detailInfo.customer_id)
                        this.getList()
                        this.rowClick(this.refreshSale)
                    },error=>{
                        this.tip(error.data.message,"warning");
                        this.sure_params.settlement_time=new Date();
                    })
                }).catch(()=>{});
            },
            // 刷新详情页面
            retrunDetail(data){
                this.rowClick(data);
                this.getList();
            },
            //添加付款单
            addOrderSheetBack(){
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                    this.postFuncLoading("/erp/finance.inout",this.add_params,()=>{
                        this.tip("付款成功","success")
                        this.addDialogVisibleBack=false;
                        // this.dialogVisible=false;
                        this.getBillMess(this.detailInfo.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //开发票
            addOrderBill(){
                this.$confirm('是否确认开发票?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_billParams.invoice_time=this.formatTimeZero(this.invoice_time)
                    this.postFuncLoading("/erp/invoice.create",this.add_billParams,()=>{
                        this.tip("操作成功","success")
                        this.addDialogVisibleBill=false;
                        // this.dialogVisible=false;
                        // this.getBillMess(this.detailInfo.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //添加收款单
            addOrderSheet(){
                this.$confirm('是否确认收款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                    this.postFuncLoading("/erp/finance.inout",this.add_params,()=>{
                        this.tip("收款成功","success")
                        this.addDialogVisible=false;
                        // this.dialogVisible=false;
                        this.getBillMess(this.detailInfo.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getRow(row){
                this.selectRow=row;
                let selectGetMoney = 0;
                this.selectRow.forEach(item=>{
                    selectGetMoney += Number(item.receivable_amount)
                })
                this.selectGetMoney = parseFloat(selectGetMoney).toFixed(2);
            },
            rowClick(obj){
                let total_number = 0;
                this.refreshSale = obj;
                if(obj.name==="order_sn"){
                    this.postFuncLoading("/erp/order.order",{id:obj.id},res=>{
                        let resD = res.data.data;
                        res.data.data.relate_list.forEach(item =>{
                        if(item.rec == 1){
                            total_number += Number(item.amount);
                        }
                    })
                    resD.tax_rec_amount = total_number;
                        if(resD.rec_type=='DIV'){
                            resD.rec_type = 2
                        }else{
                            resD.rec_type = 1
                        }
                        this.newFee = resD.fee_list;
                        this.detailInfo = this.$cloneJson(resD);
                        let source = this.saleBillSource = resD.status === 111 ? 'return' : 'order';
                        let scene = `finance.${source}.column`;
                        this.dialogVisible = true;
                        if (this.saleBillScene === scene) {
                        }else{
                            this.saleBillScene = scene;
                        }
                        this.detailInfo.saleOrderIsEdit = false;
                        this.detailInfo.recIsEdit =true;
                        this.detailInfo.outstanding = resD.outstanding;
                        this.detailInfo.isOrderOutPass = resD.isOrderOutPass;
                        this.detailInfo.isInout = resD.isInout;
                        this.detailInfo.isSettlement = resD.isSettlement;
                        this.detailInfo.isPayment = resD.isPayment;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else if(obj.name==="invoice_yes"){
                    this.seeBillList_id = obj.id;
                    this.dialogVisibleBill = true;
                }else if(obj.name==="see"){
                    sessionStorage.removeItem("DEMU_ERP_SUMMARY_ID")
                    sessionStorage.setItem("DEMU_ERP_SUMMARY_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '明细详情'+obj.id,
                        label: '明细详情',
                        content: 'summaryDetail'
                    });
                }else if(obj.name=='customer_name'){
                     this.postFunc('erp/customer.detail',{id:obj.row.customer_id},resD=>{
                        this.isSeeEdit = true
                        this.customerDetail = true
                        let resData = resD.data.data
                        resData.province_id = resData.province_id === 0 ? '' : resData.province_id
                        resData.city_id = resData.city_id === 0 ? '' : resData.city_id
                        resData.star = resData.star === 0 ? '' : resData.star
                        resData.customer_source_id = resData.customer_source_id === 0 ? '' : resData.customer_source_id
                        resData.customer_attribute_id = resData.customer_attribute_id === 0 ? '' : resData.customer_attribute_id
                        resData.salesman_id = resData.salesman_id              
                        this.form_params = resD.data.data
                    })
                }else{
                    this.listDetailObj.id=obj.id;
                    let data=this.$cloneJson(obj.row);
                    switch(obj.name){
                        case "traffic_amount":
                            this.openRelative(true, obj.id, "/erp/finance.update.relate.receivables");
                            // this.listDetailObj.type=1;
                            // this.listDetailObj.amount=data.traffic_amount;
                            // this.listDetailObj.remark=data.traffic_amount_remark;
                            break;
                        case "other_amount":
                            this.listDetailObj.type=3;
                            this.listDetailObj.other_amount=data.other_amount;
                            this.listDetailObj.other_amount_remark=data.other_amount_remark;
                            this.otherVisible=true;
                            break;
                        case "reduce_amount":
                            this.listDetailObj.type=4;
                            this.listDetailObj.reduce_amount=data.reduce_amount;
                            this.listDetailObj.reduce_amount_remark=data.reduce_amount_remark;
                            this.reduceVisible=true;
                            break;
                    }
                    if(obj.name=='tax_manual'&&data.rec==1&&Number(data.tax_rate)==0){
                        this.listDetailObj.tax_manual=data.tax_manual;
                        this.listDetailObj.tax_manual_remark=data.tax_manual_remark;
                        this.taxVisible=true;
                    }
                }
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            customerCloses(){
                this.customerDialogVisibles = false;
            },
            Customerion(){
                this.getList();
                this.customerDialogVisibles = false;
                this.params.search.customer_name = '';
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time = this.formatTimeZero(this.start_time);
                this.params.search.end_time = this.formatTimeZero(this.end_time);
                this.params.search.start_predict_time = this.formatTimeZero(this.start_predict_time);
                this.params.search.end_predict_time = this.formatTimeZero(this.end_predict_time);
                this.params.search.start_audit_time = this.formatTimeZero(this.start_audit_time);
                this.params.search.end_audit_time = this.formatTimeZero(this.end_audit_time);
                this.params.search.clear_start_time = this.formatTimeZero(this.clear_start_time);
                this.params.search.clear_end_time = this.formatTimeZero(this.clear_end_time);
                this.params.search.start_out_time = this.formatTimeZero(this.start_out_time);
                this.params.search.end_out_time = this.formatTimeZero(this.end_out_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/finance.receivables",this.params,response=>{
                    this.last_page=parseInt(response.data.data.last_page);
                    // this.params.page=parseInt(response.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(response.data.data.total);
                    this.totalObj.already_amount=response.data.data.already_amount;
                    this.totalObj.outstanding_amount=response.data.data.outstanding_amount;
                    this.totalObj.reduce_amount=response.data.data.reduce_amount;
                    this.totalObj.tax_amount=response.data.data.tax_amount;
                    this.totalObj.tax_manual=response.data.data.tax_manual;
                    this.totalObj.receivable_amount=response.data.data.receivable_amount;
                    this.totalObj.sales_amount=response.data.data.sales_amount;
                    this.totalObj.invoice_yes=response.data.data.invoice_yes;
                    this.totalObj.invoice_no=response.data.data.invoice_no;
                    this.list = response.data.data.list;
                    this.list.forEach((item,index)=>{
                        item.see="明细详情";
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }else{
                            this.list[index].sales_time = "";
                        }
                        if(item.out_time!=0){
                            this.list[index].out_time = this.formatTime(item.out_time+"000")
                        }else{
                            this.list[index].out_time = "";
                        }
                        if(item.predict_time!=0){
                            this.list[index].predict_time = this.formatTime(item.predict_time+"000")
                        }else{
                            this.list[index].predict_time = "";
                        } 
                        if(item.settlement_time!=0){
                            this.list[index].settlement_time = this.formatTime(item.settlement_time+"000")
                        }else{
                            this.list[index].settlement_time = "";
                        }
                        if(item.audit_time!=0){
                            this.list[index].audit_time = this.formatTime(item.audit_time+"000")
                        }else{
                            this.list[index].audit_time = "";
                        }
                        if(Number(item.outstanding)!=0){
                            this.list[index].baseColor="#ff0000";
                        }else{
                            this.list[index].baseColor="";
                        }
                        // if(item.rec==0){
                        //     item.rec="否"
                        // }else if(item.rec==1){
                        //     item.rec="是"
                        // }
                        // item.rec=item.res_text;
                        item.isCanClickUnInclude=item.invoice_yes;
                        this.list[index].sales_amount = parseFloat(item.sales_amount).toFixed(2);
                        this.list[index].already_amount = parseFloat(item.already_amount).toFixed(2);
                        this.list[index].outstanding = parseFloat(item.outstanding).toFixed(2);
                        this.list[index].traffic_amount = parseFloat(item.traffic_amount).toFixed(2);
                        this.list[index].tax_amount = parseFloat(item.tax_amount).toFixed(2);
                        this.list[index].other_amount = parseFloat(item.other_amount).toFixed(2);
                        this.list[index].reduce_amount = parseFloat(item.reduce_amount).toFixed(2);
                    })
                    this.last_page = response.data.data.last_page;
                    this.summary.sales_amount = response.data.data.sales_amount;
                    this.summary.reduce_amount = response.data.data.reduce_amount;
                    this.summary.already_amount = response.data.data.already_amount;
                    this.summary.outstanding_amount = response.data.data.outstanding_amount;
                    this.filter = response.data.data.column;
                    this.copy_filter = JSON.parse(JSON.stringify(response.data.data.column))
                    this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_text"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                        if(item.colKey=="see"){
                            item.isShow=true;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            search(){
                if (this.params.page == 1) {
                    this.getList()
                } else {
                    this.params.page = 1;
                }
            },

            reset(){
                this.params = this.$cloneJson(initSearchParams);
                this.start_audit_time = "";
                this.end_audit_time = "";
                this.clear_start_time = "";
                this.clear_end_time = "";
                this.start_out_time = "";
                this.end_out_time = "";
                this.start_time = "";
                this.end_time = new Date();
                this.start_predict_time = "";
                this.end_predict_time = "";
                // this.$refs['selectdowncustomer'].clearData()
                this.getList();
            },

            // 审核通过
            orderOut(id){
                this.$confirm('是否确定审核通过?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/finance.allow.shipping",{order_ids : id.toString()},()=>{
                        this.tip("审核成功","success")
                        // this.dialogVisible=false;
                        this.detailInfo.isOrderOutPass = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{})
            },
            batchOrderOut(){
                if(this.selectRow.length<1){
                    this.tip("请选择销售单","warning")
                }else{
                    let flag = true;
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isOrderOutPass){
                            flag = false;
                            this.tip("选择订单中有不可出库项","warning")
                            return;
                        }else{
                            arr.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.orderOut(arr)
                    }
                }
            },
            changeaddAmounta(e,input){
                e.target.value=(e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.add_params.amount=this.input
            },
            changeaddAmount(e,input){
                e.target.value=(e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.add_params.amount=this.input
            },
            changeAmount(e,input){
                e.target.value=(e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.sure_params.amount=this.input
            },
            changeRate(e,input){
                e.target.value=(e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.sure_params.reduce_amount=this.input
            },
            //优惠计算
            calcTaxAmount(){
                if((0<Number(this.sure_params.reduce_amount) && Number(this.sure_params.reduce_amount)<Number(this.sure_params.amount))||Number(this.sure_params.reduce_amount)==''){
                    if(this.sure_params.reduce_amount==""){
                        this.sure_params.amount=this.$bc_add(this.detailInfo.outstanding_amount,this.detailInfo.reduce_amount);
                    }else{
                        this.sure_params.amount =this.$bc_sub(this.$bc_add(this.detailInfo.outstanding_amount,this.detailInfo.reduce_amount),this.sure_params.reduce_amount);
                    }
                }else if(Number(this.sure_params.reduce_amount)>Number(this.detailInfo.outstanding_amount)){
                    this.tip("优惠金额得小于结算金额"+this.detailInfo.outstanding_amount,"warning")
                }        
            },
            calcTaxAmounts(){
                if((Number(this.sure_params.amount)<Number(this.sure_params.reduce_amount) && Number(this.sure_params.reduce_amount)<0)||Number(this.sure_params.reduce_amount)==''||this.sure_params.reduce_amount=='-'){
                    if(Number(this.sure_params.reduce_amount)==""||this.sure_params.reduce_amount=='-'){
                        this.sure_params.amount=this.$bc_add(this.detailInfo.outstanding_amount,this.detailInfo.reduce_amount);
                    }else{
                        this.sure_params.amount =this.$bc_sub(this.$bc_add(this.detailInfo.outstanding_amount,this.detailInfo.reduce_amount),this.sure_params.reduce_amount);
                    }
                }else if(this.sure_params.reduce_amount<this.detailInfo.outstanding_amount){
                    this.tip("优惠金额得大于结算金额"+this.detailInfo.outstanding_amount,"warning")
                }    
            }   
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                }
            },
            'addDialogVisibleBill':function(val){
                if(!val){
                    this.add_billParams=this.resetJson(this.add_billParams)
                    this.add_billParams.name = "增值税专用发票";
                }else{
                    if(this.$refs['selectStock']){
                        this.$refs['selectStock'].getList();
                    }
                }
            },
            "sureDialogVisible":function(val){
                if(!val){
                    this.sure_params=this.resetJson(this.sure_params)
                    this.sure_params.settlement_time=new Date()
                }
            },
            "listDialogVisible":function(val){
                if(!val){
                    this.listDetailObj=this.resetJson(this.listDetailObj)
                }
            },
            "sure_params.reduce_amount":function(){
                // this.sure_params.reduce_amount = this.$digitInput(this.sure_params.reduce_amount, 2, false);
                if(this.sure_params.amount>0){
                    this.calcTaxAmount();
                }else if(this.sure_params.amount<0){
                     this.calcTaxAmounts();
                }
            }
        }
    }
</script>
